import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { FormsModule } from '@angular/forms';
import { DatepickerService } from '@shared/services/datepicker.service';

@Component({
  selector: 'iho-date-of-stay-modal',
  standalone: true,
  imports: [CommonModule, MatRadioModule, MatButtonModule, FormsModule],
  templateUrl: './date-of-stay-modal.component.html',
  styleUrls: ['./date-of-stay-modal.component.scss'],

})
export class DateOfStayModalComponent implements OnInit {
  modalData: any;
  packages: any;
  filterPackages: any;
  pdpUiService = inject(HotelInfoUiService)
  selectedPackage: any = {};
  selectedPackageVal: number = 0;
  isSend = false;
  packagesItems:any;
  datepickerService = inject(DatepickerService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DateOfStayModalComponent>
  ) {
    this.modalData = data;
    this.packages = this.modalData.package;
  }

  ngOnInit(): void {
    // handled filters packages
    const [syear, smonth, sday] = this.datepickerService._startDate().split('/');
    const [eyear, emonth, eday] = this.datepickerService._endDate().split('/');
    let startDate = `${syear}/${('0' + smonth).slice(-2)}/${('0' + sday).slice(-2)}`;
    let endDate = `${eyear}/${('0' + emonth).slice(-2)}/${('0' + eday).slice(-2)}`;


    let find = this.modalData.package.filter((item: any) => item.allRooms == false && item.roomId == this.modalData.roomId);
    let findAll = this.modalData.package.filter((item: any) => item.allRooms == true && item.roomId == this.modalData.roomId);
    if(find.length && findAll.length){
      findAll = findAll.filter((item: any) =>
        (startDate >= item.startDatePersian && startDate <= item.endDatePersian) ||
        (endDate >= item.startDatePersian && endDate <= item.endDatePersian) ||
        (startDate <= item.startDatePersian && endDate >= item.endDatePersian)
      );
      this.packages = [...find, ...findAll];
      return
    }
    if (find.length){
      this.packages = find;
      return
    }
    if (findAll.length) {
      findAll = findAll.filter((item: any) =>
        (startDate >= item.startDatePersian && startDate <= item.endDatePersian) ||
      (endDate >= item.startDatePersian && endDate <= item.endDatePersian) ||
      (startDate <= item.startDatePersian && endDate >= item.endDatePersian)
    );
    this.packages = findAll;
      return
    }

  }


  selectedNights(night: any) {
    this.selectedPackage = {};
    this.isSend = false;
    this.packages = this.packagesItems;
    this.selectedPackageVal = 0;
    this.filterPackages.forEach((item: any, index: number) => {
      if (item.night === night) {
        item.selected = true;
      } else {
        item.selected = false;

      }
    });
    if (night === 0) {
      this.packages = this.packages;
    } else {
      this.packages = this.packages.filter((item: any) => item.night == night)
    }
  }
  setSearch() {
    if (Object.keys(this.selectedPackage)?.length) {
      this.pdpUiService.setPackage(this.selectedPackage.startDatePersian, this.selectedPackage.endDatePersian);
      this.dialogRef.close();

    }

  }
  selectPackage(item: any) {
    this.isSend = true;
    this.selectedPackage = item;
  }

}
